function getRpcUrls(): RPC_URLS_TYPE {
    const http = import.meta.env.VITE_JSON_RPC_URL as string
    const ws = import.meta.env.VITE_WS_PRC_URL as string

    if (!http || !ws) {
        throw new Error('Invalid rpc url');
    }

    return {
        http,
        ws
    }
}

export type RPC_URLS_TYPE = { http: string, ws: string }
export const RPC_URLS: RPC_URLS_TYPE = getRpcUrls()